// @flow
import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Container from '@material-ui/core/Container';
import styles from './Tabs.module.scss';

const CompanyTabs = ({
  id,
  title,
  tabs,
  contents,
}: {
  id: string,
  title: string,
  tabs: Array<Object>,
  contents: Array<Object>,
}) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box id={id}>
      <Container className={styles.container}>
        <Box py="70px" textAlign="center">
          <Typography variant="h2" component="h3">
            {title}
          </Typography>
        </Box>
        <Tabs
          scrollButtons="off"
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="nav-tabs"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              id={`nav-tab-${tab.id}`}
              aria-controls={`nav-tabpanel-${tab.id}`}
              disableRipple
            />
          ))}
        </Tabs>
        {contents.map((content, index) => (
          <div
            key={index}
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tab-${content.id}`}
            aria-labelledby={`nav-tab-${content.id}`}
          >
            {content.component}
          </div>
        ))}
      </Container>
    </Box>
  );
};

export default CompanyTabs;
